export default "__VITE_ASSET__BCncnEcU__"